import type { FlagKey } from "@/hooks/useFeatureFlags/flags";

export const GRP_PERSON_PROFILE_FLAG = "backoffice-grp-person-profile" satisfies FlagKey;

/** The FAA table reads consents for this many campaigns, so the Add FAA picker offers the same set. */
export const GRP_COMMISSION_CAMPAIGNS_LIMIT = 20;
